import { useCallback } from 'react'
import type { SeatType } from '~/lib/graphql/graphql'
import type { DateText, HourMinute } from '~/lib/graphql/scalars'
import { useReserveNavigate } from '~/navigation'

export function useNavigateWithSelectDateTime() {
  const navigate = useReserveNavigate()
  return useCallback(
    (condition: {
      visitorsCount: number
      visitDate: DateText
      visitTime: HourMinute
      seatTypes?: SeatType[]
      windowSide?: boolean
    }) => {
      navigate({
        type: 'selectDateTime',
        ...condition,
      })
    },
    [navigate]
  )
}
